module.exports = __webpack_public_path__ + "static/TED2019-f335e4eda73d94dfcccd8ad40ddc8aa8.jpg";